export default "__VITE_ASSET__DC6LlrU5__"